import { render, staticRenderFns } from "./gkTestC.vue?vue&type=template&id=221c3ed0&scoped=true&"
import script from "./gkTestC.vue?vue&type=script&lang=js&"
export * from "./gkTestC.vue?vue&type=script&lang=js&"
import style0 from "./gkTestC.vue?vue&type=style&index=0&id=221c3ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c3ed0",
  null
  
)

export default component.exports